import React from 'react';
import clsx from 'clsx';
import { MultiValueProps } from 'react-select/src/components/MultiValue';
import { OptionTypeBase } from 'react-select/src/types';
import { Chip } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';

export const MultiValue = (props: MultiValueProps<OptionTypeBase>) => {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={clsx(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
};
